import { createOccupation } from '@/services';
import { mapActions } from 'vuex';
import { LEAD_TYPES, INVITATION_STATUS } from '@/utils/constants';
export default {
    name: 'OfferFreeOccupation',
    props: {
        show: Boolean,
        width: String,
        height: String,
        isMobile: Boolean,
        competition: Object,
        fromMeeting: Boolean
    },
    methods: {
        ...mapActions('notification', ['showNotification']),
        async nonPayingSlotOccupation() {
            try {
                const payload = {
                    competition: this.competition.id,
                    from_meeting: this.fromMeeting,
                    status: INVITATION_STATUS.FREE_OCCUPATION,
                    payment_type: LEAD_TYPES.FREE_PANEL,
                    transaction_id: LEAD_TYPES.FREE_PANEL
                };
                await createOccupation(payload);
                this.showNotification({ text: 'Compra realizada com sucesso!', type: 'success' });
            } catch (e) {
                console.log(e);
                this.showNotification({ text: 'Erro ao tentar adiquirir cotação', type: 'error' });
            } finally {
                this.$emit('initializeData', true);
                this.$emit('close', false);
            }
        }
    }
};
